import { combineReducers } from '@reduxjs/toolkit'
import { combineEpics } from 'redux-observable'

import {
  epics as institutionEpics,
  actions as institutions,
  registerReducer as institutionsReducer,
} from 'institutions'
import { epics as matchEpics, registerReducer as matchReducer } from 'match'
import { actions as notifications, registerReducer as notificationsReducer } from 'notifications'
import { actions as players, registerReducer as playersReducer } from 'players'
import { epics as searchV2Epics, registerReducer as searchV2Reducer } from 'search'
import { actions as site, reducer as siteReducer } from 'site'
import { actions as teams, epics as teamsEpics, registerReducer as teamsReducer } from 'teams'
import { epics as tournamentEpics, actions as tournaments, registerReducer as tournamentsReducer } from 'tournaments'
import { epics as usersEpics, registerReducer as usersReducer } from 'users'

import * as auth from '../actions/AuthActions'
import * as environment from '../actions/EnvironmentActions'
import { userRegisterEpic } from '../actions/RegisterActions'
import * as institutionsList from '../components/institutions/list/actions'
import institutionListReducer from '../components/institutions/list/reducer'
import * as search from '../components/site/SearchActions'
import searchReducer from '../components/site/SearchReducer'
import * as playerDetails from '../components/sports/PlayerDetailsActions'
import playerDetailsReducer from '../components/sports/PlayerDetailsReducer'
import { disregardedListFetchEpic } from '../components/sports/soccer/matches/DisregardedListActions'
import disregardedListReducer from '../components/sports/soccer/matches/DisregardedListReducer'
import { lineupsFetchEpic } from '../components/sports/soccer/matches/LineupsActions'
import lineupsReducer from '../components/sports/soccer/matches/LineupsReducer'
import { playingNowFetchEpic } from '../components/sports/soccer/matches/PlayingNowActions'
import playingNowReducer from '../components/sports/soccer/matches/PlayingNowReducer'
import * as teamsList from '../components/sports/soccer/teams/list/actions'
import teamListReducer from '../components/sports/soccer/teams/list/reducer'
import * as tournament from '../components/sports/soccer/TournamentActions'
import tournamentReducer from '../components/sports/soccer/TournamentReducer'
import { tournamentListFetchEpic } from '../components/sports/tournaments/TournamentListActions'
import tournamentListReducer from '../components/sports/tournaments/TournamentListReducer'
import * as userNotifications from '../components/users/notifications/NotificationsActions'
import userNotificationsReducer from '../components/users/notifications/NotificationsReducer'
import * as post from '../components/wall/PostListActions'
import postListReducer from '../components/wall/PostListReducer'
import * as institutionPage from '../pages/institution/InstitutionPageActions'
import institutionPageReducer from '../pages/institution/InstitutionPageReducer'
import * as matchPage from '../pages/sports/soccer/MatchPageActions'
import matchPageReducer from '../pages/sports/soccer/MatchPageReducer'
import * as teamPage from '../pages/sports/soccer/TeamPageActions'
import teamPageReducer from '../pages/sports/soccer/TeamPageReducer'
import * as tournamentPage from '../pages/sports/TournamentPage/actions'
import tournamentPageReducer from '../pages/sports/TournamentPage/reducer'
import * as stats4nerds from '../pages/Stats4NerdsActions'
import statsReducer from '../pages/Stats4NerdsReducer'
import * as playerPage from '../pages/user/PlayerPageActions'
import playerPageReducer from '../pages/user/PlayerPageReducer'
import * as userPage from '../pages/UserPageActions'
import userPageReducer from '../pages/UserPageReducer'
import * as userSettings from '../pages/UserSettingsActions'
import userSettingsReducer from '../pages/UserSettingsReducer'
import authReducer from './AuthReducer'
import environmentReducer from './EnvironmentReducer'
import registerReducer from './RegisterReducer'
import systemMessageReducer from './SystemMessageReducer'

const state = {
  auth: authReducer,
  disregardedList: disregardedListReducer,
  environment: environmentReducer,
  institution: institutionPageReducer,
  institutions: institutionListReducer,
  lineups: lineupsReducer,
  match: matchPageReducer,
  message: systemMessageReducer,
  playerDetails: playerDetailsReducer,
  playerPage: playerPageReducer,
  playingNow: playingNowReducer,
  posts: postListReducer,
  register: registerReducer,
  search: searchReducer,
  site: siteReducer,
  stats: statsReducer,
  team: teamPageReducer,
  teams: teamListReducer,
  tournament: tournamentReducer,
  tournamentPage: tournamentPageReducer,
  tournaments: tournamentListReducer,
  user: userPageReducer,
  userNotifications: userNotificationsReducer,
  userSettings: userSettingsReducer,
}

const reducersRegisterList = [
  institutionsReducer,
  matchReducer,
  notificationsReducer,
  playersReducer,
  searchV2Reducer,
  usersReducer,
  teamsReducer,
  tournamentsReducer,
]

export default () => combineReducers(reducersRegisterList.reduce((store, reducer) => reducer(store), state))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filterEpics = (obj: Record<string, any>) =>
  Object.keys(obj)
    .filter((k) => k.endsWith('Epic'))
    .map((k) => obj[k])
export const epics = combineEpics(
  ...filterEpics(auth),
  ...filterEpics(environment),
  ...filterEpics(institutionPage),
  ...filterEpics(institutions),
  ...filterEpics(institutionsList),
  ...filterEpics(matchPage),
  ...filterEpics(notifications),
  ...filterEpics(playerDetails),
  ...filterEpics(playerPage),
  ...filterEpics(players),
  ...filterEpics(post),
  ...filterEpics(search),
  ...filterEpics(site),
  ...filterEpics(stats4nerds),
  ...filterEpics(teamPage),
  ...filterEpics(teams),
  ...filterEpics(teamsList),
  ...filterEpics(tournament),
  ...filterEpics(tournamentPage),
  ...filterEpics(tournaments),
  ...filterEpics(userNotifications),
  ...filterEpics(userPage),
  ...filterEpics(userSettings),

  disregardedListFetchEpic,
  lineupsFetchEpic,
  playingNowFetchEpic,
  tournamentListFetchEpic,
  userRegisterEpic,

  ...institutionEpics,
  ...matchEpics,
  ...searchV2Epics,
  ...usersEpics,
  ...teamsEpics,
  ...tournamentEpics,
)
